var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup113279(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 200,
    viewBox: "0 0 140 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.4 58.2936H125.5V198.694H0.5V24.6936H91.9V57.7936V58.2936H92.4Z",
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4 51.2936H132.5V191.694H7.5V17.6936H98.9V50.7936V51.2936H99.4Z",
    fill: "#514C9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4 51.2936H132.5V191.694H7.5V17.6936H98.9V50.7936V51.2936H99.4Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4 51.2936H132.5V191.694H7.5V17.6936H98.9V50.7936V51.2936H99.4Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4 51.2936H132.5V191.694H7.5V17.6936H98.9V50.7936V51.2936H99.4Z",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.4 44.2936H139.5V184.694H14.5V10.6936H105.9V43.7936V44.2936H106.4Z",
    fill: "white",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.4 10.1936L140 43.7936H106.4V10.1936Z",
    fill: "#ECEBFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.7598,
    y: 16.4666,
    width: 39.9,
    height: 39.9,
    transform: "rotate(-11 21.7598 16.4666)",
    fill: "#514C9F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7598,
    y: 16.4666,
    width: 39.9,
    height: 39.9,
    transform: "rotate(-11 21.7598 16.4666)",
    fill: "white",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7598,
    y: 16.4666,
    width: 39.9,
    height: 39.9,
    transform: "rotate(-11 21.7598 16.4666)",
    fill: "white",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6653 19.0924L37.7127 25.7893C38.6485 28.8502 41.8885 30.5729 44.9494 29.6371V29.6371C48.0103 28.7013 49.7331 25.4613 48.7973 22.4004L43.7139 5.77359C42.7781 2.71269 39.5381 0.989955 36.4772 1.92577L36.2463 1.99637C33.3129 2.89319 31.662 5.99818 32.5588 8.93155V8.93155L32.9003 10.1932",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6504 90.3435H117.25",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6504 97.3435H117.25",
    stroke: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6504 111.343H117.25",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6504 125.343H117.25",
    stroke: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6504 153.343H47.2504",
    stroke: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6504 160.343H47.2504",
    stroke: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.299,
    cy: 86.4936,
    rx: 16.1,
    ry: 16.1,
    fill: "#514C9F",
    fillOpacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M125.65 107.843L114.85 97.0435M104.05 102.443C101.922 102.443 99.8156 102.024 97.8501 101.21C95.8847 100.396 94.0988 99.2029 92.5945 97.6986C91.0902 96.1943 89.8969 94.4084 89.0828 92.4429C88.2686 90.4775 87.8496 88.3709 87.8496 86.2435C87.8496 84.116 88.2686 82.0095 89.0828 80.044C89.8969 78.0785 91.0902 76.2926 92.5945 74.7883C94.0988 73.284 95.8847 72.0907 97.8501 71.2766C99.8156 70.4625 101.922 70.0435 104.05 70.0435C108.346 70.0435 112.467 71.7502 115.505 74.7883C118.543 77.8264 120.25 81.9469 120.25 86.2435C120.25 90.54 118.543 94.6605 115.505 97.6986C112.467 100.737 108.346 102.443 104.05 102.443Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup113279);
export default __webpack_public_path__ + "static/media/Group 113279.2080d3a12b916525d73d281732cced22.svg";
export { ForwardRef as ReactComponent };